module.exports = __webpack_public_path__ + "static/media/corporate_party-icon.58066587.svg";